import ClipAPI from './clip';
import ExternalAPI from './external';
import MediaAPI from './media';
import PipelineAPI from './pipeline';
import ModelsAPI from './models';
import RenderTemplatesAPI from './renderTemplates';

// Unified API object for backward compatibility
const API = {
  // Clip
  createIdea: ClipAPI.createIdea,
  createIdeas: ClipAPI.createIdeas,
  getIdeas: ClipAPI.getIdeas,
  deleteIdea: ClipAPI.deleteIdea,
  createClipPromptFromJson: ClipAPI.createClipPromptFromJson,
  createClipPrompt: ClipAPI.createClipPrompt,
  getClipPrompts: ClipAPI.getClipPrompts,
  getClipPrompt: ClipAPI.getClipPrompt,
  editClipPrompt: ClipAPI.editClipPrompt,
  editClipMetadata: ClipAPI.editClipMetadata,
  getClipStyles: ClipAPI.getClipStyles,
  getClipStyleSchema: ClipAPI.getClipStyleSchema,
  deleteClipPrompt: ClipAPI.deleteClipPrompt,
  deleteClipAudio: ClipAPI.deleteClipAudio,
  renderClip: ClipAPI.renderClip,
  cancelClipRender: ClipAPI.cancelClipRender,
  reviewReel: ClipAPI.reviewReel,
  getAvailableMedia: ClipAPI.getAvailableMedia,
  hydrateClip: ClipAPI.hydrateClip,

  // Media
  getMediaItem: MediaAPI.getMediaItem,
  createMediaItem: MediaAPI.createMediaItem,
  listMediaLibrary: MediaAPI.listMediaLibrary,
  listMediaLibraryPaged: MediaAPI.listMediaLibraryPaged,
  uploadMediaLibraryFile: MediaAPI.uploadMediaLibraryFile,
  renameMediaLibraryItem: MediaAPI.renameMediaLibraryItem,
  createImage: MediaAPI.createImage,
  createAIVideo: MediaAPI.createAIVideo,
  createAudio: MediaAPI.createAudio,
  editMediaItem: MediaAPI.editMediaItem,
  regenerateMedia: MediaAPI.regenerateMedia,
  editMediaMetadata: MediaAPI.editMediaMetadata,
  replaceMediaMetadata: MediaAPI.replaceMediaMetadata,
  deleteMediaItem: MediaAPI.deleteMediaItem,
  toggleFavourite: MediaAPI.toggleFavourite,
  lipSyncMedia: MediaAPI.lipSyncMedia,

  // Pipeline Runs
  startPipeline: PipelineAPI.startPipeline,
  getPipeline: PipelineAPI.getPipeline,
  listPipelines: PipelineAPI.listPipelines,
  continuePipeline: PipelineAPI.continuePipeline,
  regenerateCheckpoint: PipelineAPI.regenerateCheckpoint,
  selectCheckpointOutput: PipelineAPI.selectCheckpointOutput,
  injectCheckpointPrompt: PipelineAPI.injectCheckpointPrompt,
  addPipelineAttachment: PipelineAPI.addAttachment,

  // Pipeline Templates
  createPipelineTemplate: PipelineAPI.createPipelineTemplate,
  getPipelineTemplate: PipelineAPI.getPipelineTemplate,
  listPipelineTemplates: PipelineAPI.listPipelineTemplates,
  updatePipelineTemplate: PipelineAPI.updatePipelineTemplate,
  deletePipelineTemplate: PipelineAPI.deletePipelineTemplate,

  // Prompt Templates
  createPromptTemplate: PipelineAPI.createPromptTemplate,
  getPromptTemplate: PipelineAPI.getPromptTemplate,
  listPromptTemplates: PipelineAPI.listPromptTemplates,
  updatePromptTemplate: PipelineAPI.updatePromptTemplate,
  deletePromptTemplate: PipelineAPI.deletePromptTemplate,

  // Models
  getModels: ModelsAPI.getModels,
  getChatModels: ModelsAPI.getChatModels,
  getImageModels: ModelsAPI.getImageModels,
  getVideoModels: ModelsAPI.getVideoModels,
  getModelConstraints: ModelsAPI.getModelConstraints,
  getModelsForProvider: ModelsAPI.getModelsForProvider,

  // Remotion render templates and proposals
  listRenderTemplates: RenderTemplatesAPI.listRenderTemplates,
  createRenderTemplate: RenderTemplatesAPI.createRenderTemplate,
  updateRenderTemplate: RenderTemplatesAPI.updateRenderTemplate,
  deleteRenderTemplate: RenderTemplatesAPI.deleteRenderTemplate,
  listRenderProposals: RenderTemplatesAPI.listRenderProposals,
  createRenderProposal: RenderTemplatesAPI.createRenderProposal,
  patchRenderProposalStatus: RenderTemplatesAPI.patchRenderProposalStatus,

  // External
  addUser: ExternalAPI.addUser,
  getUsers: ExternalAPI.getUsers,
  setActiveUser: ExternalAPI.setActiveUser,
  removeUser: ExternalAPI.removeUser,
  refreshAccounts: ExternalAPI.refreshAccounts,
  getActiveAccount: ExternalAPI.getActiveAccount,
  setActiveAccount: ExternalAPI.setActiveAccount,
  scheduleClip: ExternalAPI.scheduleClip,
  resolveTelegramUsername: ExternalAPI.resolveTelegramUsername,
  sendToTelegram: ExternalAPI.sendToTelegram,
  getTelegramSendJob: ExternalAPI.getTelegramSendJob,
  sendCarouselToTelegram: ExternalAPI.sendCarouselToTelegram,

  // Prompt Enhancement
  enhancePrompt: ExternalAPI.enhancePrompt,
};

export default API;

// Re-export individual APIs for direct access
export { ClipAPI, MediaAPI, ExternalAPI, PipelineAPI, RenderTemplatesAPI };

// Re-export structs and helpers
export * from './structs';
export * from './helpers';
